export default __webpack_public_path__ + "static/media/background-batik.f41e938a.jpg";